import type { contact_order_by } from '@vrplatform/graphql';

export const orderByContact: contact_order_by[] = [
  {
    type: 'asc_nulls_last',
  },
  {
    name: 'asc_nulls_last',
  },
];
